import { CarBodyType, CarDoors, CarGearBox, CarRefItemStatus } from "../constants/car-basic-data";
import { CarEngine } from "./car-engine.model";
import { CarFeature } from "./car-feature.model";

export class CarModel {
    id: number = 0;
    
    code = '';
    name = '';
    details = '';
    startYear = 1900;
    endYear = 2099;

    makeId: number = 0;
    makeCode = '';
    makeName = '';

    versions: string[] = [];
    engines: CarEngine[] = [];
    features: CarFeature[] = [];

    bodyTypes: CarBodyType[] = [];
    gearBoxes: CarGearBox[] = [];
    doors: CarDoors[] = [];

    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string)  {
        this.code = code!;
        this.name = name!;
    }
  }
  